import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc3bc57e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-tip__wrapper" }
const _hoisted_2 = { class: "input-tip__content" }

import Popper from 'vue3-popper'

import IconInfoCircle from '@C/ui/icons/IconInfoCircle.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'InputTip',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popper), {
    class: "input-tip",
    interactive: "",
    arrow: "",
    placement: "top",
    "offset-distance": "0"
  }, {
    content: _withCtx((props) => [
      _createElementVNode("article", _hoisted_2, [
        _renderSlot(_ctx.$slots, "content", _normalizeProps(_guardReactiveProps(props)))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default"),
        _createVNode(IconInfoCircle, { class: "input-tip__icon" })
      ])
    ]),
    _: 3
  }))
}
}

})